// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1384e49c","826":"b954313c"}[chunkId] + ".chunk.js";
};